import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface IGetSitesParams extends IGetItemsParams {
}

export interface IGetSitesResult extends IGetItemsResult {
  sites: ISiteSettingsForServerAdmin[];
}

export class GetSitesRequest extends Request<IGetSitesParams, IGetSitesResult> {
  constructor(params: IGetSitesParams) {
    super('getSites', params);
  }
}
